"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var OrderedList = _styledComponents["default"].ol.withConfig({
  displayName: "Breadcrumbs__OrderedList",
  componentId: "sc-1kbbbp9-0"
})(["display:flex;flex-flow:row wrap;padding:0;list-style-type:none;"]);

var ListItem = _styledComponents["default"].li.withConfig({
  displayName: "Breadcrumbs__ListItem",
  componentId: "sc-1kbbbp9-1"
})(["display:flex;line-height:1rem;align-items:center;white-space:nowrap;a{padding:0;}"]);
/**
 *
 * ### Styled 'Breadcrumbs' component

This component accepts a collection of child components that will be rendered with a common separator. Its main purpose is for navigation using a collection of `Link` components. This would represent a visible path and position of the site map. Each link would provide context for a visible page, and shortcuts back to previous pages.
 */


var _ref2 = /*#__PURE__*/_react["default"].createElement(ListItem, {
  "aria-hidden": true
}, /*#__PURE__*/_react["default"].createElement(_uiIcons.CaretRight, {
  size: 16
}));

var Breadcrumbs = function Breadcrumbs(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("nav", {
    "aria-label": "breadcrumb"
  }, /*#__PURE__*/_react["default"].createElement(OrderedList, null, _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "child-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement(ListItem, null, child), index < children.length - 1 && _ref2);
  })));
};

var _default = Breadcrumbs;
exports["default"] = _default;